import { Claims } from '../utils/services/cache/ClientCache'
const axios = require('axios');

export const getMonsterLabByStudentNumber = async (studentNumber) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}Student/GetMonsterLabByStudentNumber/${studentNumber}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const createMonster = (studentNumber) => {
    var bodyFormData = new FormData();
    bodyFormData.set('studentNumber', studentNumber);

    return axios({
        method: 'post',
        url: `${process.env.WEB_API}StudentMonster/CreateMonster`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};


export const getGetMonsterDetailByStudentNumber = async (studentNumber) => {
    return await axios({
        method: 'get',
        url: `${process.env.WEB_API}StudentMonster/GetMonsterDetail/${studentNumber}`,
        headers: {
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const feedMonster = async (studentNumber) => {
    var bodyFormData = new FormData();
    bodyFormData.set('studentNumber', studentNumber);

    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}StudentMonster/FeedMonster`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};

export const getMonsterBack = async (studentNumber) => {

    var bodyFormData = new FormData();
    bodyFormData.set('studentNumber', studentNumber);

    return await axios({
        method: 'post',
        url: `${process.env.WEB_API}StudentMonster/GetMonsterBack`,
        data: bodyFormData,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Claims.getToken()}`
        }
    })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            //handle error
            console.error(error);
            return error.response.status;
        });
};